import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";

import CascateList from "../../../../../../common/components/cascate_list";
import DefaultInput from "../../../../../../common/components/default_input";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { GestaoEpiDropdown } from "../../../../domain/models/gestao_epi_dropdown";
import { useMemo } from "react";
import { FornecedorDropDown } from "../../../../../../common/domain/models/fornecedor_dropdown";
import { DefaultDateRangePickerInput } from "../../../../../../common/components/default_date_range_picker_input";

/**
 * Header
 */

type Props = {
  idsGestaoEpi: number[] | null;
  idsFornecedores: number[] | null;
  ca: string | null;
  dataRecebimento: (Date | null)[] | null;
  dataValidade: (Date | null)[] | null;
  gestaoEpiDropdown: GestaoEpiDropdown[];
  fornecedoresDropdown: FornecedorDropDown[];
  onGestaoEpiChange: (ids: number[] | null) => void;
  onFornecedoresChange: (ids: number[] | null) => void;
  onCaChange: (ca: string | null) => void;
  onDataRecebimentoChange: (data: (Date | null)[] | null) => void;
  onDataValidadeChange: (data: (Date | null)[] | null) => void;
  onClearFilters: () => void;
};

export const Header = ({
  idsGestaoEpi,
  idsFornecedores,
  ca,
  dataRecebimento,
  dataValidade,
  gestaoEpiDropdown,
  fornecedoresDropdown,
  onGestaoEpiChange,
  onFornecedoresChange,
  onCaChange,
  onDataRecebimentoChange,
  onDataValidadeChange,
  onClearFilters,
}: Props) => {

  const selectedGestaoEpis = useMemo(() => {
    if (idsGestaoEpi === null || idsGestaoEpi.length === 0) return null;
    return gestaoEpiDropdown.filter(x => idsGestaoEpi.some(y => y === x.idGestaoEpi));
  }, [
    idsGestaoEpi,
    gestaoEpiDropdown,
  ]);

  const selectedFornecedores = useMemo(() => {
    if (idsFornecedores === null || idsFornecedores.length === 0) return null;
    return fornecedoresDropdown.filter(x => idsFornecedores.some(y => y === x.idFornecedor));
  }, [
    idsFornecedores,
    fornecedoresDropdown,
  ]);

  return (
    <CascateList title="Filtros" defaultOpen={true}>
      <div className="w-full flex flex-col gap-4">
        <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <DefaultMultiAutocomplete
            label='Nome de EPIs'
            options={gestaoEpiDropdown}
            getOptionLabel={x => x.nome}
            getOptionKey={x => x.idGestaoEpi}
            value={selectedGestaoEpis}
            onChange={e => onGestaoEpiChange(e !== null && e.length !== 0 ? e.map(x => x.idGestaoEpi) : null)}
          />

          <DefaultMultiAutocomplete
            label='Fornecedores'
            options={fornecedoresDropdown}
            getOptionLabel={x => x.nomeFantasia}
            getOptionKey={x => x.idFornecedor}
            value={selectedFornecedores}
            onChange={e => onFornecedoresChange(e !== null && e.length !== 0 ? e.map(x => x.idFornecedor) : null)}
          />

          <DefaultInput
            name='ca'
            label='Certificado de Aprovação'
            value={ca}
            onChangeValue={onCaChange}
          />

          <DefaultDateRangePickerInput
            label="Data de Recebimento"
            dataDe={dataRecebimento?.[0] ?? null}
            dataAte={dataRecebimento?.[1] ?? null}
            onChange={(de, ate) => {
              if (de === null && ate === null) {
                onDataRecebimentoChange(null);
              }
              else if (de === null) {
                onDataRecebimentoChange([de, null]);
              }
              else if (ate === null) {
                onDataRecebimentoChange([null, ate]);
              }
              onDataRecebimentoChange([de, ate]);
            }}
          />

          <DefaultDateRangePickerInput
            label="Data de Validade"
            dataDe={dataValidade?.[0] ?? null}
            dataAte={dataValidade?.[1] ?? null}
            onChange={(de, ate) => {
              if (de === null && ate === null) {
                onDataValidadeChange(null);
              }
              else if (de === null) {
                onDataValidadeChange([de, null]);
              }
              else if (ate === null) {
                onDataValidadeChange([null, ate]);
              }
              onDataValidadeChange([de, ate]);
            }}
          />
        </div>

        <div className="w-full flex justify-end">
          <div className="w-[180px]">
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
              buttonColor="yellow"
              onClick={onClearFilters}>
              Limpar filtros
            </PrimaryButton>
          </div>
        </div>
      </div>
    </CascateList>
  );
}